var avatar = 'fx_e395032e_1ara3ml6';
var avatarBackground = 'var(--fx_e395032e_1ara3ml3)';
var avatarFontSize = 'var(--fx_e395032e_1ara3ml1)';
var avatarFontWeight = 'var(--fx_e395032e_1ara3ml2)';
var avatarIconSize = 'var(--fx_e395032e_1ara3ml4)';
var avatarRoot = 'fx_e395032e_1ara3ml5';
var avatarSize = 'var(--fx_e395032e_1ara3ml0)';

export { avatar, avatarBackground, avatarFontSize, avatarFontWeight, avatarIconSize, avatarRoot, avatarSize };
//# sourceMappingURL=avatar.vanilla.mjs.map
